/**
 * Event names/payload shapes for tracking calls that live in shared libs/satellite mixins
 * (e.g. appointmentMixinBase, monitorWebsocketConnectionMixin) and are consumed by more than
 * one app. Each app still owns how the event is actually sent — a typed MixpanelPlugin
 * composable or a legacy mixpanel mixin — this file is only the single source of truth for the
 * event name/payload shape so apps don't duplicate (and risk diverging) them.
 */
export const SharedEvents = {
  APPOINTMENT_ID_COPIED: 'Action: Appointment ID Copied',
  WEBSOCKET_CONNECTION_ERROR: 'Error: Websocket connection failure'
} as const;

export interface AppointmentIdCopiedPayload {
  'Org Name': string;
  'Org ID': string;
  'Appointment ID': string;
}
